import EmptyStateIcon from "../../src/assets/svg/emptyState.svg";

export interface EmptyStateProps {
  title: string;
  message: string;
}

export function EmptyState(props: EmptyStateProps) {
  return (
    <div className="flex flex-col gap-3 px-4 sm:px-0">
      <div>
        <img src={EmptyStateIcon} alt="Empty paper"></img>
      </div>
      <div className="flex flex-col gap-2">
        <h2 className="text-base font-bold uppercase text-gray-extra-dark">
          {props.title}
        </h2>
        <p className="text-[13px] text-gray-extra-dark text-opacity-80">
          {props.message}
        </p>
      </div>
    </div>
  );
}

export default EmptyState;
